import LoginFrame from './login-frame';

export default LoginFrame;
